import React, { useRef } from "react";
import { useInstantSearch } from "react-instantsearch";
import { useSelector } from "react-redux";

import AllFiltersButton from "../../UI/AllFiltersButton/AllFiltersButton";
import CustomSort from "../Sort/CustomSort";
import CustomList from "./CustomList";
import { refinementSidebarAnimation } from "./refinementsidebar-animations";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import "./RefinementSidebar.scss";

const RefinementSidebar = (props) => {
    const {
        SEARCH_INDEX,
        SEARCH_PRICE_ASC_INDEX,
        SEARCH_PRICE_DESC_INDEX,
        SEARCH_SHIPPINGTIMEINDAYS_ASC_INDEX,
        SEARCH_SHIPPINGTIMEINDAYS_DESC_INDEX,
    } = useSelector((state) => state.config);

    const { results } = useInstantSearch();

    const componentRef = useRef(null);

    useGSAP(
        () => {
            const timeline = gsap.timeline();

            timeline.add(refinementSidebarAnimation(), 0.5);
        },
        {
            dependencies: [componentRef],
            scope: componentRef.current,
        },
    );
    return (
        <div
            className="search-sidebar"
            ref={componentRef}
            style={{ display: results.nbHits > 0 ? "grid" : "none" }}
        >
            <>
                <CustomSort
                    items={[
                        {
                            value: SEARCH_INDEX,
                            label: "Relevanz",
                        },
                        {
                            value: SEARCH_PRICE_ASC_INDEX,
                            label: "Preis Aufsteigend",
                        },
                        {
                            value: SEARCH_PRICE_DESC_INDEX,
                            label: "Preis Absteigend",
                        },
                        {
                            value: SEARCH_SHIPPINGTIMEINDAYS_ASC_INDEX,
                            label: "Lieferdatum Aufsteigend",
                        },
                    ]}
                />
                <CustomList />
                <AllFiltersButton />
            </>
        </div>
    );
};

export default RefinementSidebar;
